import React from 'react'
import { Link } from 'react-router-dom'
import { ChevronRight } from 'lucide-react'

export interface BreadcrumbItem {
  label: string
  to?: string
}

export const Breadcrumb: React.FC<{ items: BreadcrumbItem[] }> = ({ items }) => (
  <nav className="flex min-h-8 items-center gap-1.5 text-[13px] leading-none" aria-label="Breadcrumb">
    {items.map((item, i) => (
      <React.Fragment key={i}>
        {i > 0 && (
          <ChevronRight className="h-3.5 w-3.5 shrink-0 text-slate-400 dark:text-slate-500" />
        )}
        {item.to ? (
          <Link
            to={item.to}
            className="max-w-[160px] truncate text-slate-500 transition-colors hover:text-blue-800 dark:text-slate-400 dark:hover:text-slate-100"
          >
            {item.label}
          </Link>
        ) : (
          <span className="text-slate-800 dark:text-slate-100 font-medium truncate max-w-[220px]">
            {item.label}
          </span>
        )}
      </React.Fragment>
    ))}
  </nav>
)
